module.exports = __webpack_public_path__ + "img/isologo.5119ca14.png";